/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

export interface IUpdateShippingAddressAgain {
    updateShippingAddress?: boolean;
}

export class UpdateCheckoutShippingAddressInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `shouldUpdateShippingAddress`;
    public getCacheObjectType = () => 'shouldUpdateShippingAddress';
    public dataCacheType = (): CacheType => 'none';
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new UpdateCheckoutShippingAddressInput();
};

export async function shouldUpdateShippingAddressAction(
    input: UpdateCheckoutShippingAddressInput,
    ctx: IActionContext
): Promise<IUpdateShippingAddressAgain> {
    return { updateShippingAddress: undefined };
}

export default createObservableDataAction<IUpdateShippingAddressAgain>({
    action: <IAction<IUpdateShippingAddressAgain>>shouldUpdateShippingAddressAction,
    input: createInput
});
